import { Injectable, NgZone } from '@angular/core';
import { env } from './../environments/env';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GoogleAuthService {
  GoogleAuth: any;
  isAuthorized: boolean;
  currentApiRequest: any;
  public gapiHealthcare$: Subject<any> = new Subject();

  constructor(private zone: NgZone) {
    this.isAuthorized = false

  }

  async gapi_Load() {
    gapi.load("client:auth2", this.gapiLoadObj())
  }

  gapiLoadObj() {
    return {
      callback: () => {
        this.gapi_ClientLoad()
          .then((res) => {
            if (res === 200) {
              console.log(200)
              return true
            }
          });
      },
      onerror: (error) => {
        console.log(error)
      }
    }
  }

  gapi_ClientLoad() {
    return gapi.client
      .init(
        {
          'apiKey': env.config.gapi.apiKey,
          'clientId': env.config.gapi.clientId,
          'discoveryDocs': [env.config.gapi.healthcareRest_v1beta1],
          'scope': env.config.gapi.platformScope
        }
      )
      .then(() => {
        this.GoogleAuth = gapi.auth2.getAuthInstance();
        this.GoogleAuth.isSignedIn.listen(this.gapi_updateSigninStatus);
        this.GoogleAuth.signIn().then((equis) => {
          console.log("signedIN")
          this.gapiHealthcare$.next(gapi.client['healthcare']);
        }, (error) => {
          console.log(error)
        })
        return 200;
      }, (err) => {
        console.log('error:', err);
      })
  }

  gapi_setSigninStatus(isSignedIn) {
    var user = this.GoogleAuth.currentUser.get();
    var isAuthorized = user.hasGrantedScopes(env.config.gapi.platformScope);
    if (isAuthorized) {
      /* $('#sign-in-or-out-button').html('Sign out');
      $('#revoke-access-button').css('display', 'inline-block');
      $('#auth-status').html('You are currently signed in and have granted ' +
        'access to this app.'); */
    } else {
      /* $('#sign-in-or-out-button').html('Sign In/Authorize');
      $('#revoke-access-button').css('display', 'none');
      $('#auth-status').html('You have not authorized this app or you are ' +
        'signed out.'); */
    }
  }

  gapi_sendAuthorizedApiRequest(requestDetails) {
    this.currentApiRequest = requestDetails;
    if (this.isAuthorized) {
      // Make API request
      // gapi.client.request(requestDetails)
      console.log("// gapi.client.request(requestDetails)")
      // Reset currentApiRequest variable.
      this.currentApiRequest = {};
    } else {
      this.GoogleAuth.signIn();
    }
  }

  gapi_updateSigninStatus(isSignedIn) {
    if (isSignedIn) {
      this.isAuthorized = true;
      if (this.currentApiRequest) {
        this.gapi_sendAuthorizedApiRequest(this.currentApiRequest);
      }
    } else {
      this.isAuthorized = false;
    }
  }
}
